module.exports = __webpack_public_path__ + "static/media/discussion.dfed879d.svg";